import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchPrescreenQuestions } from 'actions/prescreen';
import { Button, NonIdealState, Intent } from '@blueprintjs/core';

import PrescreenAddQuestionDrawer from 'containers/Manage-Questionnaire/prescreen/local/PrescreenAddQuestionDrawer';
import PrescreenReorderDrawer from 'containers/Manage-Questionnaire/prescreen/local/PrescreenReorderDrawer';

import colors from 'utils/colors';
import Pagination from 'components/pagination';
import { FlexRow } from 'components/styled-components';
import { QuestionnaireControls } from 'components/forms/questionnaire-management/controls';
import PrescreenTableRow from 'containers/Manage-Questionnaire/prescreen/PrescreenTableRow';
import FilterMenu from 'containers/Manage-Questionnaire/prescreen/FilterMenu';
import Loading from 'components/loading';
import { AppToaster } from 'components/AppToaster';

import { reorderPrescreeningQuestions } from 'api/prescreen'

const initialState = {
  prescreenIndex: null,
  currentPage: 0,
  perPage: 10,
  searchQuery: '',
  addingPrescreenQuestion: false,
  reorderingPrescreenQuestion: false,
  filter: null,
  filterField: null,
  displayFilter: '',
};

class PrescreenTable extends Component {
  state = { ...initialState };
  componentDidMount() {
    this.fetchQuestions();
  }

  componentWillUnmount() {
    this.setState({ ...initialState });
  }

  buildParams = () => {
    const { filter, filterField, searchQuery } = this.state;
    return {
      ...(filter && {
        [filterField]: parseInt(filter.value),
      }),
      ...(searchQuery && { searchQuery }),
    };
  };

  fetchQuestions = () => {
    const params = this.buildParams();
    const { currentPage, perPage } = this.state;
    this.props.fetchPrescreenQuestions({
      ...params,
      start: currentPage * perPage,
      limit: perPage,
    });
  };

  openPrescreenAddQuestion = () =>
    this.setState({ addingPrescreenQuestion: true });
  closePrescreenAddQuestion = () =>
    this.setState({ addingPrescreenQuestion: false });

	openPrescreenReorder = () => this.setState({ reorderingPrescreenQuestion: true });
	closePrescreenReorder = () => this.setState({ reorderingPrescreenQuestion: false });

  handlePageClick = currentPage => {
    this.setState({ currentPage }, () => {
      this.fetchQuestions();
    });
  };

  handlePerPageChange = perPage => {
    this.setState({ perPage: perPage.value, currentPage: 0 }, () => {
      this.fetchQuestions();
    });
  };

  handleSearch = searchQuery =>
    this.setState({ searchQuery, currentPage: 0 }, () => this.fetchQuestions());

  setPrescreenIndex = prescreenIndex => this.setState({ prescreenIndex });

  handleChangeFilter = (filter, filterField, displayFilter) => {
    this.setState({ filter, filterField, displayFilter, currentPage: 0 }, () =>
      this.fetchQuestions()
    );
  };

  handleSaveOrder = (updatedQuestions) => {
	reorderPrescreeningQuestions(updatedQuestions)
		.then(res => {
			//close drawer
			this.closePrescreenReorder();
			//toast the message
			AppToaster.show({
				message: res.data.message,
				intent: Intent.SUCCESS,
			});
			//reload the questions (for order)
			this.fetchQuestions();
		})
		.catch(error => {
			AppToaster.show({
				message: error.response.data.message,
				intent: Intent.DANGER,
			});
		});
  };

  clearFilters = () => {
    this.setState(
      { filter: null, filterField: null, displayFilter: '', currentPage: 0 },
      () => this.fetchQuestions()
    );
  };

  render() {
    const { questions, isFetching, categories } = this.props;
    const { searchQuery } = this.state;
    return (
      <>
        <FlexRow>
          <div style={{ width: '70%', marginLeft: '1rem' }}>
            <QuestionnaireControls
              value={searchQuery}
              handleSearch={this.handleSearch}
              active={0}
            >
              <FilterMenu
                categories={categories}
                handleChangeFilter={this.handleChangeFilter}
                selectedFilter={this.state.filter}
                displayFilter={this.state.displayFilter}
                questionStatus={this.props.questionStatus}
                clearFilters={this.clearFilters}
              />
            </QuestionnaireControls>
          </div>

          <div>
            <Button
              minimal
              onClick={this.openPrescreenAddQuestion}
              style={{
                color: colors.primary,
                fontSize: '0.9rem',
                marginRight: '3rem',
              }}
              text="+ ADD QUESTION"
            />
            <PrescreenAddQuestionDrawer
              closeDrawer={this.closePrescreenAddQuestion}
              openDrawer={this.openPrescreenAddQuestion}
              isOpen={this.state.addingPrescreenQuestion}
              categories={categories}
              fetchPrescreenQuestions={this.fetchQuestions}
            />
          </div>
		  <div>
            <Button
				minimal
				onClick={this.openPrescreenReorder}
				style={{
					color: colors.primary,
					fontSize: '0.9rem',
					marginRight: '3rem',
				}}
				text="Re-Order Questions"
            />
			<PrescreenReorderDrawer
				closeDrawer={this.closePrescreenReorder}
				openDrawer={this.openPrescreenReorder}
				isOpen={this.state.reorderingPrescreenQuestion}
				questions={questions}
				handleSaveOrder={this.handleSaveOrder}
			/>
		  </div>
        </FlexRow>
        {isFetching ? (
          <Loading size={100} />
        ) : questions.totalCount ? (
          questions.result.map((question, i) => (
            <PrescreenTableRow
              question={question}
              index={i}
              key={`${i}-${question.questionID}`}
              total={questions.total}
              setPrescreenIndex={this.setPrescreenIndex}
              currentIndex={this.state.prescreenIndex}
              fetchQuestions={this.fetchQuestions}
              categories={categories}
              filter={this.state.filter}
              filterField={this.state.filterField}
              searchQuery={searchQuery}
            />
          ))
        ) : (
          <NonIdealState
            icon={searchQuery ? 'search' : 'error'}
            title="No results found"
            description={
              searchQuery
                ? 'Your search did not match any questions'
                : 'There was an error fetching the questions.'
            }
          />
        )}

        <Pagination
          numRecords={questions.totalCount}
          perPage={this.state.perPage}
          currentPage={this.state.currentPage}
          onPageClick={this.handlePageClick}
          handlePerPageChange={this.handlePerPageChange}
        />
      </>
    );
  }
}
const mapStateToProps = state => ({
  questions: state.prescreen.questions,
  isFetching: state.prescreen.isFetching,
  questionTypes: state.utils.questionTypes,
  categories: state.utils.categories,
  questionStatus: state.utils.questionStatus,
});

PrescreenTable = connect(
  mapStateToProps,
  {
    fetchPrescreenQuestions,
  }
)(PrescreenTable);

export default PrescreenTable;
